import { useEffect } from 'react'
import { company } from './CustomerData';

export const useTwitterPixel = (leadSource) => {
  useEffect(() => {
    if (leadSource === 'Brian Kiplinger' && company.companyId === '6243c824-9e29-46da-94c6-96d03d8cbb84') {
      if (window.twq) return

      (function (e, t, n, s, u, a) {
        if (!e.twq) {
          s = e.twq = function () {
            s.exe ? s.exe.apply(s, arguments) : s.queue.push(arguments)
          }
          s.version = '1.1'
          s.queue = []
          u = t.createElement(n)
          u.async = true
          u.src = 'https://static.ads-twitter.com/uwt.js'
          a = t.getElementsByTagName(n)[0]
          a.parentNode.insertBefore(u, a)
        }
      })(window, document, 'script')

      window.twq('config', 'p72x9')
    }
  }, [leadSource]);
}

export const trackTwitterConversion = (eventId, conversionId = null, email = null, phone = null) => {
  if (window.twq) {
    window.twq('event', eventId, {
      conversion_id: conversionId,
      email_address: email,
      phone_number: phone,
    })
  }
}
